import { render, staticRenderFns } from "./bait-al-zubair-foundation.vue?vue&type=template&id=1329588d&"
import script from "./bait-al-zubair-foundation.vue?vue&type=script&lang=js&"
export * from "./bait-al-zubair-foundation.vue?vue&type=script&lang=js&"
import style0 from "./bait-al-zubair-foundation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports